/*
 * @Author: WangZhengJie wangzj@geovis.com.cn
 * @Date: 2022-05-26 08:57:06
 * @LastEditors: yangguodong yanggd@geovis.com.cn
 * @LastEditTime: 2025-10-30 15:24:18
 * @FilePath: \ngtc-traceability-admin\src\app\app-routing.module.ts
 * @Description:
 *
 * Copyright (c) 2022 by WangZhengJie wangzj@geovis.com.cn, Geovis All Rights Reserved.
 */
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AppFrameLayoutComponent } from './layout/layout-basic/app-frame-layout.component';
import { SecurityGuard } from './security/security.guard';
const routes: Routes = [
  {
    path: '',
    component: AppFrameLayoutComponent,
    canActivate: [SecurityGuard],
    children: [
      { path: 'welcome', loadChildren: () => import('./pages/welcome/welcome.module').then(m => m.WelcomeModule) },
    ]
  },
  { canActivate: [SecurityGuard],path: 'trace', loadChildren: () => import('./pages/trace/trace.module').then(m => m.TraceModule) },
  { canActivate: [SecurityGuard],path: 'personal', loadChildren: () => import('./pages/personal/personal.module').then(m => m.PersonalModule) },
  { canActivate: [SecurityGuard],path: 'sys',loadChildren:() => import('./pages/sys/sys.module').then(m => m.SysModule)},
  { canActivate: [SecurityGuard],path: 'organization', loadChildren: () => import('./pages/organization/organization.module').then(m => m.OrganizationModule) },
  { canActivate: [SecurityGuard],path: 'terminal', loadChildren: () => import('./pages/terminal/terminal.module').then(m => m.TerminalModule) },
  { canActivate: [SecurityGuard],path: 'feedback', loadChildren: () => import('./pages/feedback/feedback.module').then(m => m.FeedbackModule) },
  { canActivate: [SecurityGuard],path: 'trace', loadChildren: () => import('./pages/trace/trace.module').then(m => m.TraceModule) },
  { canActivate: [SecurityGuard],path: 'user', loadChildren: () => import('./pages/user/user.module').then(m => m.UserModule) },
  { canActivate: [SecurityGuard],path: 'category', loadChildren: () => import('./pages/category/category.module').then(m => m.CategoryModule) },
  {
    path: 'passport',
    children: [
      { path: '', pathMatch: 'full', redirectTo: '/passport/login' },
      { path: 'login', loadChildren: () => import('./pages/login/login.module').then(m => m.LoginModule) },
    ]
  },
  // {
  //   path: 'auth',
  //   children: [
  //     { path: 'sso', loadChildren: () => import('./pages/auth/sso.module').then(m => m.SSOModule) },
  //   ]
  // },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
